export default __webpack_public_path__ + "static/media/bg8.532f8575.jpg";